// extracted by css-extract-rspack-plugin
export default {"themed":"themed-_NDJDN"};